import Ocp from './Ocp'

export default Ocp
